import { useLoaderData } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { Trades } from "./Trades";
import { ITradesData } from "./TradesData";

export const tradesRouteLoader = async ({ request }: { request: any, params: any }) => {
  return doFetch(`my-profile-trades`, { signal: request.signal }, true, true);
}

export const TradesRoute = () => {
  const data = useLoaderData() as ITradesData;
  return (
    <Trades data={Object.keys(data).length === 0 ? [] : data.trades} />
  )
}